import React, { Component } from 'react';
import { connect } from 'react-redux';
import CatalogViewGrid from './catalog-view-grid';

class Products extends Component {
   constructor(props) {
      super(props);

      this.state = {
         page: 1,
         pager: { pages: [] },
         pageSize: 12,
      };
   }

   componentDidMount() {
      // set page if items array isn't empty
      if (this.props.catalogo_filtrado && this.props.catalogo_filtrado.length) {
         this.setPage(1, this.props.catalogo_filtrado);
      }
   }
   componentDidUpdate(prevProps) {
      // Verifica si `catalogo_filtrado` ha cambiado
      if (
         this.props.catalogo_filtrado !== prevProps.catalogo_filtrado &&
         this.props.catalogo_filtrado.length
      ) {
         this.setPage(1, this.props.catalogo_filtrado);
      }
   }

   setPage(page, catalogo) {
      if (page < 1) {
         return;
      }
      // Obtiene un nuevo objeto pager usando `getPager`
      const newPager = this.getPager(
         catalogo.length,
         page,
         this.state.pageSize
      );

      // Actualiza el estado con el nuevo objeto pager y la página actual
      this.setState({
         pager: newPager,
         page: page, // Muevo esto aquí desde `getPager`
      });
   }

   getPager(totalItems, currentPage, pageSize) {
      // default to first page
      currentPage = currentPage || 1;
      // default page size is 10
      pageSize = pageSize || 4;
      // calculate total pages
      var totalPages = Math.ceil(totalItems / pageSize);
      var startPage, endPage;
      if (totalPages <= 4) {
         // less than 10 total pages so show all
         startPage = 1;
         endPage = totalPages;
      } else {
         // more than 10 total pages so calculate start and end pages
         if (currentPage <= 3) {
            startPage = 1;
            endPage = 4;
         } else if (currentPage + 2 >= totalPages) {
            startPage = totalPages - 3;
            endPage = totalPages;
         } else {
            startPage = currentPage - 2;
            endPage = currentPage + 1;
         }
      }

      // calculate start and end item indexes
      // var startIndex = (currentPage - 1) * pageSize;
      // var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

      // create an array of pages to ng-repeat in the pager control
      var pages = [...Array(endPage + 1 - startPage).keys()].map(
         i => startPage + i
      );

      // return object with all pager properties required by the view
      return {
         pages: pages,
         totalPages: totalPages,
      };
   }

   render() {
      const catalogo = this.props.catalogo_filtrado;
      const pager = this.state.pager;
      const last_page = Math.ceil(catalogo.length / this.state.pageSize);
      return (
         <div className="promotions">
            <div className="justify-center">
               <div className="row">
                  <div className="column">
                     {/*<div className="promotion-title align-center color-orange">
                <div
                  className="banner-catalog"
                  style={{ backgroundImage: `url(${bannerPage})` }}
                >
                  <h2 className="catalog-name color-white">&nbsp; CATALOGO</h2>
                </div>
              </div>
              <div className="white-space-32" />*/}
                     {this.props.loading ? (
                        <div className="contenedor justify-center align-center">
                           <div className="loader3"></div>
                        </div>
                     ) : catalogo.length !== 0 ? (
                        <CatalogViewGrid itemsRow={4} page={this.state.page} />
                     ) : (
                        <div className="column align-center">
                           <div className="white-space-24"></div>
                           <h3 className="color-black">
                              No se encontraron resultados.
                           </h3>
                           <div className="white-space-24"></div>
                        </div>
                     )}
                     <div className="white-space-32" />
                     {catalogo.length > 12 ? (
                        <div className="pagination justify-center">
                           <div
                              className="first-page align-center auto"
                              onClick={() => {
                                 this.setPage(1, catalogo);
                              }}
                           >
                              <button>
                                 <i className="fas fa-angle-double-left" />
                              </button>
                           </div>
                           {pager.pages.map((page, index) => (
                              <div
                                 key={index}
                                 className={
                                    'page align-center auto ' +
                                    (page === this.state.page
                                       ? 'pagination-selected'
                                       : null)
                                 }
                                 onClick={() => this.setPage(page, catalogo)}
                              >
                                 <a>{page}</a>
                              </div>
                           ))}
                           <div
                              className="last-page align-center auto"
                              onClick={() => {
                                 this.setPage(last_page, catalogo);
                              }}
                           >
                              <button>
                                 <i className="fas fa-angle-double-right" />
                              </button>
                           </div>
                        </div>
                     ) : null}{' '}
                     {/* End Pagination */}
                     <div className="popup justify-center hidden" id="popup">
                        <div className="container align-center justify-center">
                           <i className="color-white fas fa-shopping-cart" />
                           <p className="color-white">
                              &nbsp;Añadido al Carrito
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      catalogo: state.catalogo,
      catalogo_filtrado: state.catalogo_filtrado,
      catalogo_vista: state.catalogo_vista,
      loading: state.catalogo_isLoading,
      any: state.any_categories,
   };
}

export default connect(mapStateToProps)(Products);



// WEBPACK FOOTER //
// ./src/components/Products/products.js